import { defineComponent as _defineComponent } from 'vue'
import { getHSLA } from 'ah-theme';

import { makeBarChartDataset, makeBarChartOptions } from '../helpers/chartConfig';
import VChart from './VChart.vue';
import { linesColorPrimary } from '../helpers/graphColors';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, reactive, watch } from 'vue';
import { useAhReportsState } from '..';


export default /*#__PURE__*/_defineComponent({
  __name: 'CommissionsChart',
  props: {
    graphType: null
  },
  setup(__props: any) {

const props = __props as {
  graphType: 'wallet-withdrawals' | 'trade-settled' | 'trade-all' | 'trade-scheduled';
};

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: onRetryFromParentManager,
});

function onRetryFromParentManager(k: string) {
  if (k === 'loadGraphData') {
    loadGraphData();
  }
}



const options = makeBarChartOptions({ horizontal: true, gridColor: linesColorPrimary });

const data = reactive(makeBarChartDataset());

const reportsState = useAhReportsState();

function loadGraphData() {
  requestManager.manager.sameOrCancelAndNew('loadGraphData', getDataRequest()).subscribe((response) => {
    const graphData = {
      monthToDate: response.monthToDatePartnerProfit,
      yearToDate: response.yearToDatePartnerProfit,
      allTime: response.allTimePartnerProfit,
    };
    data.datasets[0].data = Object.values(graphData);
    data.labels = ['Month to date', 'Year to date', 'All-time '];
    data.datasets[0].backgroundColor = getHSLA('widgets-green');
  });
}

watch(
  () => props.graphType,
  () => {
    loadGraphData();
  },
  { immediate: true }
);

function getDataRequest() {
  if (props.graphType === 'wallet-withdrawals') {
    return reportsState.services.wallet.getWithdrawalCommissions();
  }
  if (props.graphType === 'trade-settled') {
    return reportsState.services.trade.getSettledCommissions();
  }
  if (props.graphType === 'trade-all') {
    return reportsState.services.trade.getTotalCommissions();
  }
  return reportsState.services.trade.getScheduledCommissions();
}

const hasData = computed(() => {
  return data.datasets[0].data?.find((e) => e && typeof e === 'number' && e > 0);
});

return { __sfc: true,requestManager, onRetryFromParentManager, props, options, data, reportsState, loadGraphData, getDataRequest, hasData, VChart }
}

})